import styled from 'styled-components';

export const Button = styled.button`
  color: ${(props) => props.theme.colors['neutral-80']};
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  transition: color 0.4s ease;
  padding: 5.5px 12px;
  border: 1px solid transparent;
  border-radius: 4px;

  &:hover {
    border-color: ${({ theme }) => theme.colors['neutral-40']};
  }
`;
